import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const ResultModal = ({ result, onContinue, onQuit }) => {
  if (!result) return null;

  const isWin = result?.outcome === 'win';
  const borderColor = isWin ? 'var(--color-accent)' : 'var(--color-error)';
  const glowClass = isWin ? 'shadow-glow-green-lg' : 'shadow-glow-magenta-lg';

  return (
    <div className="fixed inset-0 z-[100] flex items-center justify-center bg-background/95 backdrop-blur-sm p-4">
      <div 
        className={`w-full max-w-md bg-card border-4 rounded-sm p-6 md:p-8 ${glowClass}`}
        style={{ borderColor }}
      >
        <div className="flex flex-col items-center gap-6">
          <div 
            className="w-20 h-20 md:w-24 md:h-24 rounded-sm border-4 flex items-center justify-center"
            style={{ borderColor, backgroundColor: `${borderColor}20` }}
          >
            <Icon 
              name={isWin ? 'Trophy' : 'Skull'} 
              size={48} 
              color={borderColor} 
            />
          </div>

          <div className="text-center space-y-2">
            <h2 
              className="text-3xl md:text-4xl font-heading font-bold"
              style={{ color: borderColor }}
            >
              {isWin ? 'VICTORY!' : 'DEFEATED!'}
            </h2>
            <p className="text-base md:text-lg font-body text-foreground">
              {result?.message}
            </p>
          </div>

          <div className="w-full space-y-4">
            <div className="bg-background border-2 border-primary/30 rounded-sm p-4 space-y-3">
              <div className="flex items-center justify-between">
                <span className="text-sm font-caption text-muted-foreground">YOUR CHOICE:</span>
                <span className="text-lg font-data text-primary">{result?.playerChoice?.toUpperCase()}</span>
              </div>
              <div className="flex items-center justify-between">
                <span className="text-sm font-caption text-muted-foreground">AI CHOICE:</span>
                <span className="text-lg font-data text-secondary">{result?.aiChoice?.toUpperCase()}</span>
              </div>
              <div className="flex items-center justify-between">
                <span className="text-sm font-caption text-muted-foreground">NUMBER:</span>
                <span className="text-lg font-data text-accent">{result?.number}</span>
              </div>
              {result?.gemsAwarded > 0 && (
                <div className="flex items-center justify-between pt-2 border-t border-accent/30">
                  <span className="text-sm font-caption text-accent">GEMS EARNED:</span>
                  <div className="flex items-center gap-2">
                    <Icon name="Gem" size={20} color="var(--color-accent)" />
                    <span className="text-xl font-data text-accent">+{result?.gemsAwarded}</span>
                  </div>
                </div>
              )}
            </div>

            <div className="grid grid-cols-2 gap-4">
              <Button
                variant="outline"
                size="lg"
                onClick={onQuit}
                iconName="Home"
                iconPosition="left"
              >
                Quit
              </Button>
              <Button
                variant="default"
                size="lg"
                onClick={onContinue}
                iconName="Play"
                iconPosition="right"
              >
                Continue
              </Button>
            </div>
          </div>

          <p className="text-xs font-caption text-muted-foreground text-center tracking-wide">
            {isWin ? 'THE AI UNDERESTIMATED YOU... THIS TIME' : 'THE AI PREDICTED YOUR MOVE PERFECTLY'}
          </p>
        </div>
      </div>
    </div>
  );
};

export default ResultModal;